export const FAVORITES_LOAD = '@@favorites/FAVORITES_LOAD';
export const FILTER_RESET = '@@favorites/FILTER_RESET';
export const FILTER_UPDATE = '@@favorites/FILTER_UPDATE';
export const FAVORITE_STATISTIC = '@@favorites/STATISTIC';



// WEBPACK FOOTER //
// ./src/app/Favorites/actionTypes.js